/**
 * The stack.plugins module houses module references to third-party
 * angular-based tools and plugins. Each tool and plugin is
 * needed for every application route.
 *
 * @module stack.plugins
 */
angular.module('stack.plugins', [
  'global',
  'ui.router',
  'ui.bootstrap',
  'ngSanitize',
  'ngAnimate',
  'ngResource'
]);
